import { render, staticRenderFns } from "./StoresDetails.vue?vue&type=template&id=045d049e&scoped=true&"
import script from "./StoresDetails.vue?vue&type=script&lang=js&"
export * from "./StoresDetails.vue?vue&type=script&lang=js&"
import style0 from "./StoresDetails.vue?vue&type=style&index=0&id=045d049e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d049e",
  null
  
)

export default component.exports